import React from 'react';
import Banner_Video from '../../assets/videos/banner.mp4';
import Banner_Image from '../../assets/images/banner_image.png';

const Banner = () => {
  return (
    <div className="relative h-screen">
      <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        poster={Banner_Image} 
      >
        <source src={Banner_Video} type="video/mp4" />
        <p>Your browser does not support the video tag.</p> 
      </video>

      {/* Mask Layer */}
      <div className="absolute top-0 left-0 w-full h-full bg-black opacity-15"></div>

      <div className="relative z-10 flex items-center justify-center w-full h-full text-white">
        <div className="text-center mx-4 sm:mx-8 md:mx-10 lg:mx-12 ">
          <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold mb-6">DURALYZE</h1>
          <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold">Accelerating the Journey to a Carbon-Free Future</h2>
          <h3 className="mt-6 text-lg md:text-xl lg:text-2xl xl:text-3xl px-4 md:px-8 lg:px-12">Creating a carbon-free future is vital for our health and the planet’s sustainability. Together, we can reduce our footprint and build a greener tomorrow.</h3>
        </div>
      </div>
    </div>
  );
};

export default Banner;
